// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jxB9","type":"styles_type__1c5J7","choices":"styles_choices__aHrU-"};